export enum BookProvidersList {
  epower = 'epower',
  alp = 'alp',
}

export enum BookTypeList {
  air = 'air',
  hotel = 'hotel',
  car = 'car',
}

export type BookLinks = { [key in BookTypeList]: string };

export interface IBookModuleConfig {
  links: BookLinks;
  provider: BookProvidersList;
  sell_connect_sku: string;
  base_url: string;
}
